// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  hmr: false,
  // baseUrl: 'https://acdb-2400-adc5-1c3-2800-1dd5-5d98-ea78-9a33.ngrok.io/trucalo',
  // baseUrl: 'http://192.168.18.5:45455',
  baseUrl: 'https://api.trucalo.nextbytesolutions.com',
  firebase: {
    apiKey: "AIzaSyDqEVQ7VYGLMZdLb_nq7NxIV-oF75EhJPc",
    authDomain: "trucalo-ed2e9.firebaseapp.com",
    projectId: "trucalo-ed2e9",
    storageBucket: "trucalo-ed2e9.appspot.com",
    messagingSenderId: "991005214134",
    appId: "1:991005214134:web:c8d7356729f7352aa42d17",
    measurementId: "G-693ZKMS6C7"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
